import React, { FunctionComponent } from 'react'

import { VIDEO_PLATFORM_DISPLAY_NAME } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/appointmentModalityConstants'
import { VIDEO_PLATFORM } from '@lyrahealth-inc/shared-app-logic/src/models/modality/Modality'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { ConfirmationModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/confirmationModal/ConfirmationModal'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

type UpdateUpcomingAvailabilitiesModalityModalProps = {
  visible: boolean
  oldPlatform: VIDEO_PLATFORM
  newPlatform: VIDEO_PLATFORM
  onRequestClose: () => void
  onUpdate: () => void
  onSkip: () => void
}

export const UpdateUpcomingAvailabilitiesModalityModal: FunctionComponent<
  UpdateUpcomingAvailabilitiesModalityModalProps
> = ({ visible, oldPlatform, newPlatform, onRequestClose, onUpdate, onSkip }) => {
  return (
    <ConfirmationModal
      testID={tID('UpdateUpcomingAvailabilitiesModalityModal')}
      visible={visible}
      onRequestClose={onRequestClose}
      modalTitle='Update your video session preference'
      modalContents={
        <BodyText
          text={`All availability with ${VIDEO_PLATFORM_DISPLAY_NAME[oldPlatform]} will automatically be updated to ${VIDEO_PLATFORM_DISPLAY_NAME[newPlatform]}.`}
        />
      }
      confirmationButtonText='Update'
      cancelButtonText='Cancel'
      onConfirmationButtonPress={onUpdate}
      onCancelPressed={onSkip}
    />
  )
}
